module.exports = __webpack_public_path__ + "img/attendant.14f39553.svg";